module.exports = __webpack_public_path__ + "static/media/om_beard_shortboxed_diamond__v.96e7caed.png";